import ProfileService from 'services/ProfileService';

import {
  fetchSharedContentRequested,
  fetchSharedContentSuccess,
} from 'actions/profile/fetchSharedContent';

export default fetchSharedContentByUrl(new ProfileService());

export function fetchSharedContentByUrl(service) {
  return url => async (dispatch) => {
    dispatch(fetchSharedContentRequested());
    const { data } = await service.fetchSharedContentByUrl(url);
    dispatch(fetchSharedContentSuccess(data));
    return data;
  };
}